import { type VFC } from 'react'

import { TYPE_CSW_ON_SERP } from 'shared/consts'
import {
  CHARGE_SEARCH_PARAMS,
  INIT_CROSSSELL,
  INIT_SLIDER,
} from 'shared/store/ducks/events'
import AsyncDataFetcher from 'views/components/molecules/AsyncDataFetcher'
import HorizontalSliderSkeleton from 'views/components/organisms/HorizontalSliderSkeleton'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

type CswOnSerpProps = {
  query: string
  widgets: Record<string, number>
}

const CswOnSerp: VFC<CswOnSerpProps> = ({ widgets, query }) => {
  return (
    <AsyncDataFetcher
      api="fock"
      apiCall="fetchCrossSell"
      callOptions={{
        path: '/crosssell/sliderHorizontal',
        params: {
          wid: widgets[TYPE_CSW_ON_SERP],
          visibleItemCount: 4,
          adaptableArrows: true,
          adaptStrategy: 'centeredBySlide',
          'ctxcustom.search': query,
          showMoreLinkUrl: true,
        },
      }}
      publishTopic={[INIT_SLIDER, CHARGE_SEARCH_PARAMS, INIT_CROSSSELL]}
      autofetch
      lazyLoad
    >
      <HorizontalSliderSkeleton
        className="a-box--white u-border-radius u-padding"
        visibleItemCount={4}
      />
    </AsyncDataFetcher>
  )
}

export default withShopAndRuntimeConfig(CswOnSerp)
